import type { UpcomingWeekGroup, UpcomingWeekItem } from './types';

export function groupUpcomingWeekItemsByDate(items: UpcomingWeekItem[]): UpcomingWeekGroup[] {
  return items.reduce<UpcomingWeekGroup[]>((groups, item) => {
    const key = `${item.day}-${item.date}`;
    const existingGroup = groups.find(group => group.key === key);

    if (existingGroup) {
      existingGroup.items.push(item);
      return groups;
    }

    groups.push({ key, items: [item] });
    return groups;
  }, []);
}
